<template>
  <vue-page-transition name="fade-in-up">
    <router-view/>
  </vue-page-transition>
</template>

<script>
export default {}
</script>
